import { Component, OnInit, Inject } from '@angular/core';
import * as _ from 'lodash';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { AttachmentTypeModel } from '../../models/attachment-type.model';
import { UploadFileExtended } from '@app/common/components/fileupload/fileupload.component';
import { AttachmentTypeCategoryEnum } from '@app/sv/enums/attachment-type-category.enum';
import { APP_BRAND } from '@app/common/services/config.service';

export interface DisabledAttachmentType {
  attachmentType: string;
  reason: string;
}

@Component({
  selector: 'attachment-choose-type-form',
  templateUrl: './attachment-choose-type-form.component.html',
})
export class AttachmentChooseTypeFormComponent implements OnInit {

  // model
  allowType: boolean;
  attachmentTypes: AttachmentTypeModel[];
  selectedAttachmentType: AttachmentTypeModel = AttachmentTypeModel.createById('OTHER');
  note = '';
  baseName = '';
  file: UploadFileExtended;

  constructor(
    @Inject(APP_BRAND) public APP_BRAND: any,
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
  ) {
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    const data = this.dialogConfig.data as DialogConfigData;
    const attachmentCategory = data.attachmentCategory;
    const defaultAttachmentType = data.defaultAttachmentType;
    this.allowType = data.allowType;
    this.file = data.file;

    this.attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory(attachmentCategory));
    if (this.APP_BRAND.NAME === 'RSD') {
      _.remove(this.attachmentTypes, (i) => i.id === 'INFORMATION_LETTER');
      _.remove(this.attachmentTypes, (i) => i.id === 'ENTRY_PROPOSAL');
      _.remove(this.attachmentTypes, (i) => i.id === 'ENTRY_PROPOSAL_NOTIFICATION');
    }

    // check disabled types
    for (const disabledAttachmentType of (data.disabledAttachmentTypes || [])) {
      const found = this.attachmentTypes.find(dt => dt.id === disabledAttachmentType.attachmentType);
      if (found) {
        found.disabled = disabledAttachmentType.reason;
      }
    }

    this.baseName = this.file.title;
    if (defaultAttachmentType) {
      this.selectedAttachmentType = defaultAttachmentType;
    }
  }

  onUpdateType(attachmentType: AttachmentTypeModel) {
    this.selectedAttachmentType = attachmentType;
  }

  isValid() {
    return this.baseName && this.selectedAttachmentType && (!this.selectedAttachmentType.extensions || this.selectedAttachmentType.extensions.includes(this.file.extension));
  }

  onSave() {
    this.dialogComponent.close({ type: this.selectedAttachmentType.id, note: this.note, baseName: this.baseName });
  }

  onCancel() {
    this.dialogComponent.close(false);
  }
}
